<template>
    <div>
        <h4 class="text-h6">
            {{ label }}
            <span v-if="totalScore"> ({{ score(totalScore) }}) </span>
        </h4>

        <div v-for="result in qualifyingResults" :key="result.id">
            <inertia-link :href="`/result-categories/${result.category_id}`">
                {{ meet(result.meet_id).title }}
            </inertia-link>
            <v-chip v-if="event === 'TI'" color="green" x-small dark>
                {{ score(result.prelims_score_without_tof) }}
            </v-chip>
            <v-chip v-else color="green" x-small dark>{{ score(result.prelims_score) }}</v-chip>
        </div>

        <div v-for="result in nonQualifyingResults" :key="result.id">
            <inertia-link :href="`/result-categories/${result.category_id}`">
                {{ meet(result.meet_id).title }}
            </inertia-link>
            <v-chip v-if="event === 'TI'" color="red" x-small dark>
                {{ score(result.prelims_score_without_tof) }}
            </v-chip>
            <v-chip v-else color="red" x-small dark>{{ score(result.prelims_score) }}</v-chip>
        </div>

        <div v-if="!qualifyingResults.length && !nonQualifyingResults.length">
            No meets found where qualification score was met.
        </div>
    </div>
</template>

<script>
import numeral from 'numeral';
import get from 'lodash/get.js';
import has from 'lodash/has.js';
import Meet from '@/Models/Meet.js';

export default {
    name: 'QualificationResult',

    props: {
        label: {
            type: String,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },

        qualifier: {
            type: Object,
            required: true,
        },
    },

    data: () => ({}),

    computed: {
        totalScore() {
            return get(this.eventQualifications, 'qualification.total_score');
        },

        qualifyingResults() {
            return get(this.eventQualifications, 'qualifying_results', []);
        },

        nonQualifyingResults() {
            return get(this.eventQualifications, 'non_qualifying_results', []);
        },

        eventQualifications() {
            return get(this.qualifier, `qualifications.${this.event}`);
        },
    },

    methods: {
        get,
        has,

        meet(meetId) {
            return Meet.find(meetId);
        },

        score(score, format = '0.0') {
            return numeral(score).format(format);
        },
    },
};
</script>
